<template>
  <div>

    <HeaderBreadcrumbs
      :items="[
        { label: 'Category', to: { name: 'category' } },
        { label: 'Edit' },
      ]"
      title="Edit Category"
    />

    <div class="bg-white w-full rounded-lg my-3 px-4 py-2.5">
      <b-row v-if="isError" class="justify-content-center mt-2">
          <b-col lg="10">
            <b-alert variant="danger" show dismissible>
              Opps .. Something is wrong
            </b-alert>
          </b-col>
        </b-row>
      <h4 class="font-bold text-xl py-2.5">Edit Category</h4>
      <div class="w-1/2 flex-col">
        <div>
          <label class="block">Category Name</label>
          <input type="text" 
          class="px-4 py-2.5 text-sm font-medium bg-gray-50 border text-gray-500 rounded-lg w-full" 
          id="name" placeholder="type category name.."
           :class="[
      submitted && !name ? 'bg-red-300 focus:ring-red-500 border-red-500 placeholder-red-500' : 'bg-gray-50 border-gray-300 text-gray-500'
    ]"
            v-model="name" />
            <p v-if="submitted && !name" class="text-red-500 text-sm mt-1 mb-0">Must be filled.</p>
        </div>
        <div class="mt-2">
          <label class="block">Content’s Type</label>
           <SelectType
             :isError="validateItemType"
             class="text-gray-500 font-normal" v-model="item_name" :options="options" :defaultText="'Select Item Type'" />
             <p v-if="submitted && !item_name" class="text-red-500 text-sm mt-1 mb-0">Must be filled.</p>
        </div>
        <div class="mt-2 mr-2">
          <label class="block">Category BiSAC</label>
          <multiselect
                  v-model="category_bisac"
                  label="name"
                  track-by="id"
                  class="custom-multiselect text-gray-500 text-sm"
                  placeholder="Select Category BISAC"
                  open-direction="bottom"
                   :class="{ 'error': submitted && !category_bisac }"
                  :options="items_category_bisac"
                  :searchable="true"
                  :loading="isLoadingSearch"
                  :close-on-select="true"
                  @search-change="asyncFind"
                >
                  <span slot="noResult">
                    Oops! No elements found. Consider changing the search query.
                  </span>
                   <template #option="{ option }">
              <div class="text-sm">
                {{ option.name }}
              </div>
            </template>
            <template #singleLabel="{ option }">
            <div class="text-sm px-2 font-medium text-gray-500">
              {{ option.name }}
            </div>
            </template>

                     <template #caret>
              <svg class="w-5 h-5 text-gray-500 absolute right-4 top-2.5" fill="none" stroke="currentColor"
                stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
            </template>
                </multiselect>
                <p v-if="submitted && !category_bisac" class="text-red-500 text-sm mt-1 mb-0">Must be filled.</p>
        </div>
         <div class="mt-2 mr-2">
            <label class="block"> Category AX</label>
           <multiselect 
           v-model="category_ax" 
           class="custom-multiselect text-gray-500 text-sm"
             :class="{ 'error': submitted && !category_ax }"
           label="name" track-by="id"
           placeholder="Select Category AX" open-direction="bottom" :options="axSearchOptions"
           :searchable="true" :loading="isAxSearch" :close-on-select="true" :multiple="false"
           @search-change="axFind">
              <template #caret>
              <svg class="w-5 h-5 text-gray-500 absolute right-4 top-2.5" fill="none" stroke="currentColor"
                stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
            </template>
              <template #singleLabel="{ option }">
            <div class="text-sm px-2 font-medium text-gray-500">
              {{ option.name }}
            </div>
            </template>
          </multiselect>
          <p v-if="submitted && !category_ax" class="text-red-500 text-sm mt-1 mb-0">Must be filled.</p>
        </div>
        <div class="mt-3 mb-4">
          <t-checkbox type="checkbox" id="is_active" v-model="is_active" />
          <label class="form-check-label" for="is_active">Active</label>
        </div>

        <div class="flex justify-start pb-3">
          <button class="bg-blue-700 text-white rounded-lg px-3 py-2" @click="updateCategory">Save</button>
          <button class="bg-white text-gray-500 rounded-lg border px-3 py-2 ml-4" @click="cancel">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import constant from '../../store/constant';
import { EventBus } from '../../event-bus'
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs.vue';
import SelectType from '../../components/form/ContentTypeSelector.vue'

const itemType = Object.entries(constant.ITEM_TYPES).map((val) => ({
  text: val[1],
  value: val[1].toLowerCase(),
}));

export default {
  name: 'EditCategoryBisac',
  components: {
    HeaderBreadcrumbs,
    SelectType
  },
  data() {
    return {
      name: '',
      item_name: 'book',
      category_bisac: '',
      items_category_bisac: [],
      category_ax : '',
      axSearchOptions: [],
      isAxSearch: false,
      id_category_bisac_old: '',
      isLoadingSearch: false,
      is_active: null,
      options: [...itemType],
      submitted: false,             
      validateItemType: false,       
    };
  },
  computed: {
    ...mapState({
      item: (state) => state.category.item,
      isError: (state) => state.category.isError,
      successMessage: (state) => state.category.successMessage,
      errorMessage: (state) => state.category.errorMessage,
    }),
  },
  watch: {
    item: function() {
      if (!Object.keys(this.item).length) return;
      this.getCategory();
    },
    isError: function() {
      if (!this.isError) return;
         EventBus.$emit('show-toast', {
        message: 'Ops. Something Went Wrong. Please Try Again',
        type: 'error',
      });
    },
    successMessage: function() {
      if (!this.successMessage) return;
         EventBus.$emit('show-toast', {
        message: 'Category has been updated.',
        type: 'success',
      });
      this.$router.push('/category');
    },
    errorMessage: function() {
      if (!this.errorMessage) return;
         EventBus.$emit('show-toast', {
        message: this.errorMessage,
        type: 'error',
      });
    },
    $route: {
      immediate: true,
      handler(to) {
        document.title = to.meta.title || 'Edit Category | Content Management System Ebooks Gramedia.com';
      }
    },
  },
  created: function() {
    const categoryID = this.$route.params.id;
    this.fetchCategoryById({ id: categoryID });
  },
  methods: {
    ...mapActions('category', ['fetchCategoryById', 'editCategory']),
    ...mapActions('category_bisac', ['searchCategoryBisac']),
    ...mapActions('ax', ['searchCategoryAx']),
   
    async getCategory() {
      const data = this.item;
      this.name = data.name;
      this.item_name = data.item_type;
      this.is_active = data.is_active;
      this.category_bisac = data.category_bisac;
      this.category_ax = data.category_ax?.ax
    },
    asyncFind(keyword) {
      if (!keyword) return;
      this.isLoadingSearch = true;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        let payload = {
          search: keyword,
        };

        this.searchCategoryBisac(payload)
          .then((response) => {
            this.items_category_bisac = response.data.data;
            this.isLoadingSearch = false;
          })
          .catch(() => {
            this.isLoadingSearch = false;
          });
      }, 600);
    },
    axFind(query) {
        if (!query) return;

        this.isAxSearch = true;
        clearTimeout(this.debounce)
        this.debounce = setTimeout(() => {
          let payload = {
            q: query,
            limit: 10,
          };
          this.searchCategoryAx(payload).then((response) => {
            this.axSearchOptions = response.data.data.rows;
            this.isAxSearch = false;
          }).catch(() => {
            this.isAxSearch = false;
          });
        }, 600);
      },
    async updateCategory() {
      this.submitted = true;
      const isContentInvalid = this.item_name === null || this.item_name === '';
      if (isContentInvalid) {
        this.validateItemType = true;
      }

      if (!this.name || !this.category_ax || !this.category_bisac || isContentInvalid) {
        return;
      }
      const categoryID = this.$route.params.id;
      let payload = {
        id: categoryID,
        item_name: this.item_name,
        name: this.name,
        category_bisac: this.category_bisac.id,
        category_ax:this.category_ax.id,
        is_active: this.is_active,
        id_category_bisac_old: this.category_bisac.id,
      };
      this.editCategory(payload);
    },
    cancel() {
      this.$router.push('/category');
    },
  },
};
</script>
